// extracted by css-extract-rspack-plugin
export default {"container":"container-Jn7NYP","transitionOverlay":"transitionOverlay-K7Yp_U","transitionIconContainer":"transitionIconContainer-BUYdp3","transitionLabel":"transitionLabel-A_sjpv"};